/**
 * Storefront auth helpers — Sanctum personal access tokens (Bearer).
 * No cookie/session/CSRF on public WebsiteAPI (breaks Nuxt SSR).
 */
import {useUserStore} from '~/store/userStore.js'

export function authHeaders(extra = {}) {
    const headers = {
        accept: 'application/json',
        ...extra,
    }

    try {
        const userStore = useUserStore()
        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`
        }
    } catch {
        // pinia not ready
    }

    return headers
}

export async function apiFetch(url, opts = {}) {
    const config = useRuntimeConfig()

    return $fetch(url, {
        baseURL: config.public.API_URL,
        ...opts,
        headers: authHeaders({
            ...(opts.headers || {}),
        }),
    })
}
